import React from 'react';
import PropTypes from 'prop-types';
import 'src/components/BoxPopularSearches.scss';

import Magnify from '@mdi/svg/svg/magnify.svg';


const BoxPopularSearches = ({ title, link }) => (
  <a data-test="seo-box-search-tile" href={ link } styleName="box-popular" title={ title }>
    <div styleName="box-popular__icon-wrap">
      <Magnify />
    </div>
    <div styleName="box-popular__content-wrap box-content">
      <h4 styleName="box-content__title">{ title }</h4>
    </div>
  </a>
);

BoxPopularSearches.propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default BoxPopularSearches;
